module.exports = __webpack_public_path__ + "static/media/gorra (1).4888d803.png";